import legoArea from './legoArea.vue';
import legoDashboardArea from './legoDashboardArea';
export default {
  install(Vue) {
    Vue.component(legoArea.name, legoArea);
    Vue.component(legoDashboardArea.name, legoDashboardArea);
  },
};
